var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "option-config",
      attrs: {
        id: "option-config",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        size: "xl"
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-8 col-12 mt-3" }, [
          _c("label", [_vm._v("Nombre de la opción")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.option.descripcion,
                expression: "option.descripcion"
              }
            ],
            staticClass: "form-control",
            attrs: { maxlength: "250" },
            domProps: { value: _vm.option.descripcion },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.option, "descripcion", $event.target.value)
              }
            }
          }),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("Nombre para identificar la opción")
          ])
        ]),
        _c("div", { staticClass: "col-md-8 col-12 mt-3" }, [
          _c("label", [_vm._v("Valor de la opción")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.option.valor,
                expression: "option.valor"
              }
            ],
            staticClass: "form-control",
            attrs: { maxlength: "250" },
            domProps: { value: _vm.option.valor },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.option, "valor", $event.target.value)
              }
            }
          }),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("Valor asignado a la opción")
          ])
        ]),
        _c("div", { staticClass: "col-md-6 col-12 mt-3" }, [
          _c("label", [_vm._v("Orden de la opción")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.option.orden,
                expression: "option.orden"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.option.orden },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.option, "orden", $event.target.value)
              }
            }
          }),
          _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v("Orden de la opción")
          ])
        ]),
        _vm.checkIfIsSuperAdmin
          ? _c("div", { staticClass: "col-md-6 col-12 mt-3" }, [
              _c("label", [_vm._v("Nivel de la opción")]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.option.nivel,
                      expression: "option.nivel"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.option,
                        "nivel",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "0", selected: "" } }, [
                    _vm._v(" Global ")
                  ]),
                  _c("option", { attrs: { value: "10" } }, [
                    _vm._v(" Empresa ")
                  ])
                ]
              ),
              _c("small", { staticClass: "form-text text-muted" }, [
                _vm._v(" Nivel de visualización del tipo de opciones (grupo) ")
              ])
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-md-12 col-12 mb-2" },
          [
            _vm._v(" Valor extra de la opción "),
            _c("vue-json-editor", {
              attrs: {
                mode: "code",
                modes: ["code"],
                "show-btns": false,
                exapndedOnStart: true
              },
              model: {
                value: _vm.extra,
                callback: function($$v) {
                  _vm.extra = $$v
                },
                expression: "extra"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        [
          !_vm.isSavingOption
            ? _c(
                "vs-button",
                {
                  staticClass: "action",
                  attrs: { color: "primary", type: "border", icon: "save" },
                  on: {
                    click: function($event) {
                      return _vm.saveOption()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            : _c("b-spinner", {
                key: "primary",
                staticClass: "mr-1",
                attrs: { variant: "primary" }
              })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }